import MapOrders from './MapOrders.view';

export default MapOrders;
